import MapPin from 'common/svg/icons/mappin.svg';
import StoragePin from 'common/svg/icons/storage-pin.svg';
const LINE_SYMBOL = { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 4 };

export const MAP_PINS = { field: MapPin, storage: StoragePin };

export const DRAWING_SHAPE_OPTIONS = {
  draggable: false,
  editable: true,
  strokeColor: '#fff',
  fillOpacity: 0.3,
  fillColor: '#fff',
  icons: [
    {
      icon: LINE_SYMBOL,
      // offset: '100%',
      offset: '0',
      repeat: '20px',
    },
  ],
  strokeOpacity: 1,
};

export const STYLES = [
  {
    featureType: 'road',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }],
  },
];



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/constants.js